import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Environment, EnvironmentService } from '@galaxy/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SalespersonRequest, SalespersonResponse } from './salesperson.objects';
import { Salesperson } from './interfaces/salesperson.interface';
import { SalespersonRequestInterface } from './interfaces/salesperson.interface';
import { map, share } from 'rxjs/operators';

/**
 * @deprecated Use SalespersonService from sales: https://github.com/vendasta/sales/blob/master/sdks/typescript/src/sales_sdk/src/lib/salesperson/salesperson.service.ts
 */
@Injectable()
export class SalespersonApiService {
  private _host: string;
  private lookupUrl = `${this.host}/internalApi/v1/salesperson/lookup/`;

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
      withCredentials: true,
    };
  }

  private get host(): string {
    if (this._host) {
      return this._host;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this._host = 'http://localhost:8086';
        break;
      case Environment.TEST:
        this._host = 'https://salestool-test.appspot.com';
        break;
      case Environment.DEMO:
        this._host = 'https://salestool-demo.appspot.com';
        break;
      case Environment.PROD:
        this._host = 'https://salestool-prod.appspot.com';
        break;
    }
    return this._host;
  }

  /**
   * @deprecated Use SalespersonService from sales: https://github.com/vendasta/sales/blob/master/sdks/typescript/src/sales_sdk/src/lib/salesperson/salesperson.service.ts
   */
  lookup(r: SalespersonRequest | SalespersonRequestInterface): Observable<SalespersonResponse[]> {
    const request = (<SalespersonRequest>r).toApiJson ? <SalespersonRequest>r : new SalespersonRequest(r);
    return this.http
      .post<any>(this.lookupUrl, null, { ...this.apiOptions(), params: request.toApiJson() as HttpParams })
      .pipe(
        map((resp) => resp.data),
        map((resp) => resp.map((salespersonData: Salesperson) => SalespersonResponse.fromProto(salespersonData))),
        share(),
      );
  }
}
